import React from 'react'
export default function HeartCircleIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
            <path fillRule="evenodd" d="M10.17 1.78a15.39 15.39 0 1 1 11.78 28.44A15.39 15.39 0 0 1 10.17 1.78Zm5.89.16a14.06 14.06 0 1 0 0 28.12 14.06 14.06 0 0 0 0-28.12Z" clipRule="evenodd"/>
            <path fillRule="evenodd" d="M16 13.44c-.67-2.78-3.56-3.33-5.23-1.9a4.03 4.03 0 0 0-.6 5.56c1.1 1.41 4.4 4.4 5.48 5.37.12.1.18.16.25.18.06.02.13.02.2 0 .06-.02.12-.07.24-.18 1.09-.97 4.39-3.96 5.48-5.37a4 4 0 0 0-.6-5.55c-1.7-1.43-4.55-.89-5.22 1.89Z" clipRule="evenodd"/>
        </svg>
    )
}


